import RouteView from '@/router/RouteView.vue';
import Bill from './index.vue';
// import Detail from "./Detail.vue";
import Statistical from '../Statistical/index.vue';
import StatisticalClass from '../Statistical/StatisticalClass';
import BillStatistical from '../Statistical/index.vue';

export default [
  {
    path: '/bill',
    name: 'Bill',
    component: RouteView,
    redirect: '/bill/list',
    meta: {
      title: '校区账单',
    },
    children: [
      {
        path: '/bill/list',
        name: 'BillList',
        component: Bill,
        meta: {
          title: '账单信息',
        },
      },
      {
        path: '/bill/statistical',
        name: 'BillStatistical2',
        component: Statistical,
        meta: {
          title: '统计',
        },
      },
      {
        path: '/bill/statistical/class/:id',
        name: 'StatisticalClass',
        component: StatisticalClass,
        meta: {
          title: '上课统计',
        },
      },
      {
        path: '/bill/goldStatistical/:type',
        name: 'Statistical',
        component: BillStatistical,
        meta: {
          title: '消费统计',
        },
      },
      // {
      //   path: '/bill/golddetail/:code',
      //   name: 'GoldDetail',
      //   component: Detail,
      //   meta: {
      //     title: '金币详单'
      //   },
      // }
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/Bill/index.js